import { module } from "angular";
import badges from "@gtmhub/badges/badges.module";
import employees from "@gtmhub/employees/employees.module";
import reflections from "@gtmhub/reflections/reflections.module";
import gridFilteringBar from "@gtmhub/shared/components/grid-filtering-bar/grid-filtering-bar.module";
import { loadModuleStyles } from "@gtmhub/shared/ng-extensions/util";
import teams from "@gtmhub/teams/teams.module";
import moduleStyles from "./people.module.less";

const mod = module("people", [reflections, teams, employees, badges, gridFilteringBar]);

loadModuleStyles(mod, moduleStyles);

export default mod.name;
